import { initContract } from '@ts-rest/core';
import {
  BareSimpleTemplate,
  TemplateSourceType,
  SimpleTemplateSchema,
  SimpleSailingTemplateSchema,
} from '../types/zod/template';
import { z } from 'zod';

const c = initContract();

export const FindTemplateParamsSchema = z.object({
  propertyId: z.string(),
  templateSources: z.enum(TemplateSourceType).optional(),
  ignoreFeed: z.boolean().optional(),
});

export const TemplateSimpleResponseSchema = z.object({
  dayTemplates: SimpleTemplateSchema.array(),
  sailingTemplates: SimpleSailingTemplateSchema.array(),
});

export type FindTemplateParams = z.infer<typeof FindTemplateParamsSchema>;

export const templateContract = c.router({
  findSimple: {
    method: 'GET',
    path: `/simple-template`,
    query: FindTemplateParamsSchema,
    responses: { 200: c.type<BareSimpleTemplate[]>() },
  },
  getTemplates: {
    method: 'GET',
    path: `/templates-simple`,
    query: FindTemplateParamsSchema,
    responses: {
      200: TemplateSimpleResponseSchema,
    },
  },
});
